import { useEffect } from 'react'
import { connect } from 'formik'

export const RecurringSelectionWatcher = connect(({ formik }) => {

  useEffect(() => {
    if (formik.touched.amount_cents) return
    formik.setFieldValue('amount_cents', formik.values.interval == 'monthly' ? 3500 : 8000)
  }, [formik.values.interval])

  return null
})
